import { render, staticRenderFns } from "./diagram-dialog.vue?vue&type=template&id=187a149b&"
import script from "./diagram-dialog.vue?vue&type=script&lang=js&"
export * from "./diagram-dialog.vue?vue&type=script&lang=js&"
import style0 from "./diagram-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports